import validation from '@/lang/es/validation';
import literals from '@/lang/es/literal';

const messages = {
  ...validation,
  ...literals,
};
export default messages;
